module.exports = __webpack_public_path__ + "media/images/icon__questionmark--rb-light-gray-a497d8a8781580df975175552f8a5259.png";